import React from 'react';
import { connect } from 'react-redux';
import Snackbar from '@material-ui/core/Snackbar';
import { createStructuredSelector } from 'reselect';
import { Alert, AlertTitle } from '@material-ui/lab';
import styled from 'styled-components';
import { setToasterOpen, setToasterClose } from 'store/global/actions';
import { getToasterObjSelector } from 'store/global/selectors';
import { injectIntl, IntlShape } from 'react-intl';
import { get } from 'lodash';
import messages from 'components/Toaster/messages';
import { translate } from 'helpers/intl';

const StyledAlertTitle = styled(AlertTitle)`
  && {
    color: #fff;
  }
`;
interface ToasterPropsType {
  toasterObj: {
    open: boolean;
    severity: 'error' | 'warning' | 'info' | 'success';
    title?: string;
    message?: string;
    subTitle?: string;
  };
  setToasterClose: Function;
  intl: IntlShape;
}
const TOASTER_DELAI = 5000;

const CustomizedSnackbars = (props: ToasterPropsType) => {
  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    /* istanbul ignore next */
    if (reason === 'clickaway') {
      return;
    }
    /* istanbul ignore next */
    props.setToasterClose();
  };
  return (
    <>
      <Snackbar
        open={props.toasterObj.open}
        autoHideDuration={TOASTER_DELAI}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          variant="filled"
          onClose={handleClose}
          severity={props.toasterObj.severity}
        >
          {props.toasterObj.title && (
            <StyledAlertTitle>
              {translate(get(messages, props.toasterObj.title), props)}
            </StyledAlertTitle>
          )}
          {props.toasterObj?.message && (
            <StyledAlertTitle>{props.toasterObj.message}</StyledAlertTitle>
          )}
          {props.toasterObj.subTitle &&
            translate(get(messages, props.toasterObj.subTitle), props)}
        </Alert>
      </Snackbar>
    </>
  );
};

const mapStateToProps = createStructuredSelector<
  any,
  {
    toasterObj: any;
  }
>({
  toasterObj: getToasterObjSelector,
});
const mapDispatchToProps = {
  setToasterOpen,
  setToasterClose,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(CustomizedSnackbars));
